import { Component, OnInit } from '@angular/core';

import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService } from '../../../../services/authentication.service';
import { WebSocketService } from '../../../../services/web-socket.service';
import { IBreadcrumbData } from '../../../../interfaces/breadcrumb-data.interface';
import { ConfigService } from '../../../../services/config.service';



@Component({
  selector: 'app-bar-control',
  templateUrl: './bar-control.component.html',
  styleUrls: ['./bar-control.component.css']
})
export class BarControlComponent implements OnInit {

  public lanes: any = [];

  /**
   * BreadcrumbData
   */
  breadcrumbData: IBreadcrumbData;

  constructor(
    private config: ConfigService,
    private snackBar: MatSnackBar,
    public wsService: WebSocketService,
    private authenticationService: AuthenticationService
  ) {

    this.breadcrumbData = {
      titles: {
        icon: 'rv_hookup',
        links: [
          {
            text: 'Lane control'
          }
        ]
      },
      description: 'Aquí puede ver el control de carril',
      buttons: []
    };

    setTimeout(() => {
      this.getLanes();
    }, 500);
  }

  ngOnInit() {
  }


  getLanes() {
    if (this.config.getConfigError()) {
      this.openSnackBar('No se ha podido cargar la configuración', '[ERROR]');
      return;
    }
    this.lanes = this.config.config.lanes;

  }

  openSnackBar(message: string, action: string) {
    console.log('openSnackBar');
    this.snackBar.open(message, action, {
      duration: 3000
    });
  }

  isModuleLaneAvailable(laneId: string) {
    return this.authenticationService.isModuleAvailable('BARCONTROL', true, laneId);
  }
}
